import React from 'react';
import { CreditCard, Plus } from 'lucide-react';
import Button from '../../../components/ui/Button';

const PaymentMethods = ({ subscription, onManageBilling, portalLoading }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
          <CreditCard className="w-5 h-5" />
          Payment Methods
        </h2>
      </div>

      <div className="space-y-4">
        <div className="border border-gray-200 rounded-lg p-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-8 bg-gradient-to-br from-blue-600 to-purple-600 rounded flex items-center justify-center">
              <CreditCard className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="font-semibold text-gray-900">Payment Method on File</p>
              <p className="text-sm text-gray-600">Managed securely through Stripe</p>
            </div>
          </div>
          <Button
            onClick={onManageBilling}
            disabled={portalLoading}
            className="bg-gray-100 hover:bg-gray-200 text-gray-900 px-4 py-2 rounded-lg text-sm font-medium"
          >
            {portalLoading ? 'Loading...' : 'Update'}
          </Button>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <CreditCard className="w-4 h-4 text-blue-600" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-blue-900 mb-1">Secure Payment Processing</h3>
              <p className="text-sm text-blue-800 mb-3">
                All payment information is securely stored and processed by Stripe. We never store your card details on our servers.
              </p>
              <ul className="text-sm text-blue-800 space-y-1">
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                  PCI DSS Level 1 certified
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                  256-bit SSL encryption
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                  Fraud detection and prevention
                </li>
              </ul>
            </div>
          </div>
        </div>

        <Button
          onClick={onManageBilling}
          disabled={portalLoading}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium flex items-center justify-center gap-2"
        >
          <Plus className="w-5 h-5" />
          {portalLoading ? 'Loading...' : 'Manage Payment Methods'}
        </Button>
      </div>
    </div>
  );
};

export default PaymentMethods;